import { render, staticRenderFns } from "./edit_groups.vue?vue&type=template&id=4388f11d&scoped=true&"
import script from "./edit_groups.vue?vue&type=script&lang=ts&"
export * from "./edit_groups.vue?vue&type=script&lang=ts&"
import style0 from "./edit_groups.vue?vue&type=style&index=0&id=4388f11d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4388f11d",
  null
  
)

export default component.exports